import { Lazy } from "../lazy";
import { InvalidParameterError } from "../exception/invalid-parameter-error";
import { NullReferenceError } from "../exception/null-reference-error";
import { ArgumentError } from "../exception/argument-error";
import { ajax } from "../network/ajax";
import { IAjax, ICache } from "./provider-interfaces";
import { localStorageCache } from "../caching/local-storage-cache";

export class ServiceProvider {
	public static getInstance = Lazy.singleton(ServiceProvider);
	public static ajaxKey = "ajax";
	public static cacheKey = "cache";

	public static get ajax(): IAjax {
		return ServiceProvider.getInstance().getService(ServiceProvider.ajaxKey);
	}

	public static get cache(): ICache {
		return ServiceProvider.getInstance().getService(ServiceProvider.cacheKey);
	}

	private serviceLocator: any = {};

	constructor() {
		this.addService(ServiceProvider.ajaxKey, ajax);
		this.addService(ServiceProvider.cacheKey, localStorageCache);
	}

	public addService<T>(serviceType: string, service: T) {
		if (serviceType == null) {
			throw new InvalidParameterError("serviceType", InvalidParameterError.nullText);
		}

		if (service == null) {
			throw new InvalidParameterError("service", InvalidParameterError.nullText);
		}

		if (this.serviceLocator[serviceType] != null) {
			throw new ArgumentError("serviceType", ArgumentError.argumentExistsText);
		}

		this.addOrUpdateService(serviceType, service);
	}

	public addOrUpdateService<T>(serviceType: string, service: T) {
		if (serviceType == null) {
			throw new InvalidParameterError("serviceType", InvalidParameterError.nullText);
		}

		if (service == null) {
			throw new InvalidParameterError("service", InvalidParameterError.nullText);
		}

		this.serviceLocator[serviceType] = service;
	}

	public removeService(serviceType: string) {
		if (serviceType == null) {
			throw new InvalidParameterError("serviceType", InvalidParameterError.nullText);
		}

		if (this.serviceLocator[serviceType] == null) {
			throw new ArgumentError("serviceType", ArgumentError.argumentNotFoundText);
		}

		delete this.serviceLocator[serviceType];
	}

	public getService(serviceType: string): any {
		if (serviceType == null) {
			throw new InvalidParameterError("serviceType", InvalidParameterError.nullText);
		}

		let service = this.serviceLocator[serviceType];

		if (service == null) {
			throw new NullReferenceError(`no service type registered with name ${serviceType}`);
		}

		return service;
	}
}